import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-yappy',
  templateUrl: './yappy.component.html',
  styleUrls: ['./yappy.component.scss'],
})
export class YappyComponent implements OnInit {
  @Input() amount: number;
  @Input() orderId: number;
  @Output() finish$ = new EventEmitter();

  public payment = {
    total: 0,
    subtotal: 0,
    shipping: 0.0,
    discount: 0.0,
    taxes: 0.0,
    orderId: 0,
    successUrl: `${environment.webSiteUrl}/yappy/success`,
    failUrl: `${environment.webSiteUrl}/yappy/success?message=failure`,
    tel: '',
    domain: environment.webSiteUrl,
  };

  constructor(
    private _vHttpSv: HttpService,
    private balanceSv: BalanceService,
    private uiSv: UiServices
  ) {}

  ngOnInit() {
    const obj = {
      amount: this.amount,
      type: 'yappy',
      currency:
        this.balanceSv.currency?.symbol || this.balanceSv.currencyBaseName,
      orderId: this.orderId,
      discount: 0,
      domainId: environment.domainId,
    };
    this.payment = {
      total: Number((this.amount + 0.01).toFixed(2)),
      subtotal: Number(this.amount.toFixed(2)),
      shipping: 0.0,
      discount: 0.0,
      taxes: 0.01,
      orderId: this.orderId,
      successUrl: `${environment.webSiteUrl}/home?successPaym=1&ori=${btoa(
        JSON.stringify(obj)
      )}`,
      failUrl: `${environment.webSiteUrl}/home?successPaym=0`,
      tel: '',
      domain: environment.webSiteUrl,
    };
  }

  async getPaymentUrl() {
    this.finish$.emit('yappy');
  }

  async sendPayment() {
    await this.uiSv.showLoading();
    const res = await this._vHttpSv.itemAction(
      this.payment,
      'purchase/yappy',
      'store'
    );

    await this.uiSv.loading.dismiss();

    if (res.status) {
      location.href = res.data.url;
    }
  }
}
